import { App } from '@ps20-frontend/frontend-models';
import { TiergruppeState } from './tiergruppe.model';

const tkvChildKeysInCardOrder = (tiergruppe: TiergruppeState): string[] => {
  const { tiere, angebotsIds } = tiergruppe;
  const cardIds = tiere.map(tier => tier.cardId).filter(cardId => Object.hasOwn(angebotsIds, cardId));
  const unmatched = Object.keys(angebotsIds).filter(cardId => !cardIds.includes(cardId));
  return [...cardIds, ...unmatched].map(cardId => angebotsIds[cardId]);
};

export const listedChildKeys = (tiergruppe: TiergruppeState): string[] => [
  ...tkvChildKeysInCardOrder(tiergruppe),
  ...(tiergruppe.thhAngelegt.thhHund ? [App.THH_HUND] : []),
  ...(tiergruppe.thhAngelegt.thhPferd ? [App.THH_PFERD] : []),
];

export const sameKeys = (first: string[], second: string[]): boolean =>
  first.length === second.length && first.every((key, index) => key === second[index]);

export const childKeyOf = (offer: { appId: App; angebotsId?: string }): string | null => {
  if (offer.appId === App.TKV_V2) {
    return offer.angebotsId ?? null;
  }
  if (offer.appId === App.THH_HUND || offer.appId === App.THH_PFERD) {
    return offer.appId;
  }
  return null;
};

export const childOfKey = (key: string): { appId: App; angebotsId?: string } => {
  if (key === App.THH_HUND) {
    return { appId: App.THH_HUND };
  }
  if (key === App.THH_PFERD) {
    return { appId: App.THH_PFERD };
  }
  return { appId: App.TKV_V2, angebotsId: key };
};
